import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import PageWrapper from '../components/PageWrapper';
import '../styles/GalleryListPage.css';

const GalleryListPage = () => {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageErrors, setImageErrors] = useState({});
  
  // Image de fallback
  const defaultImage = '/images/gallery-default.png';
  
  useEffect(() => {
    const fetchGalleries = async () => {
      try {
        setLoading(true);
        const response = await axios.get('/api/gallery');
        setGalleries(response.data.galleries);
        setLoading(false);
      } catch (err) {
        console.error('Erreur lors du chargement des galeries:', err);
        setError('Erreur lors du chargement des galeries');
        setLoading(false);
      }
    };
    
    fetchGalleries();
  }, []);
  
  // Gestionnaire d'erreur pour les images
  const handleImageError = (galleryId) => {
    console.log(`Erreur de chargement d'image pour la galerie ${galleryId}, utilisation de l'image par défaut`);
    setImageErrors(prev => ({
      ...prev,
      [galleryId]: true
    }));
  };
  
  // Obtenir l'URL de l'image de couverture via l'API
  const getCoverImageUrl = (gallery) => {
    if (!gallery.couverture || imageErrors[gallery._id]) return defaultImage;
    
    // Utiliser la nouvelle route API avec un timestamp pour éviter le cache
    const timestamp = new Date().getTime();
    return `/api/gallery/thumbnail/${gallery.couverture}?t=${timestamp}`;
  };
  
  return (
    <PageWrapper pageType="galleries">
      <div className="galleries-page">
        <div className="galleries-header">
          <h1>Galeries d'Images</h1>
          <p className="galleries-subtitle">
            Découvrez notre collection d'images téléchargeables gratuitement après inscription
          </p>
        </div>
        
        {loading ? (
          <div className="loading-galleries">
            <div className="loading-spinner"></div>
            <p>Chargement des galeries...</p>
          </div>
        ) : error ? (
          <div className="error-message">
            <p>{error}</p>
            <button onClick={() => window.location.reload()} className="retry-button">
              Réessayer
            </button>
          </div>
        ) : galleries.length === 0 ? (
          <div className="no-galleries-message">
            <p>Aucune galerie n'est disponible pour le moment.</p>
            <p>Veuillez revenir ultérieurement pour découvrir nos collections d'images.</p>
          </div>
        ) : (
          <div className="galleries-grid">
            {galleries.map(gallery => (
              <Link 
                to={`/galeries/${gallery.slug}`} 
                key={gallery._id}
                className="gallery-item"
              >
                <div className="gallery-cover">
                  <img 
                    src={getCoverImageUrl(gallery)} 
                    alt={gallery.titre}
                    onError={() => handleImageError(gallery._id)}
                  />
                </div>
                <div className="gallery-info">
                  <h2 className="gallery-title">{gallery.titre}</h2>
                  {gallery.description && (
                    <p className="gallery-description">
                      {gallery.description.length > 100 
                        ? `${gallery.description.substring(0, 100)}...` 
                        : gallery.description}
                    </p>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </PageWrapper>
  );
};

export default GalleryListPage;